export function getStatus(state) {
  return state.app.status;
}

export function getPresence(state) {
  return state.app.presence;
}

export function wasInDashboardBefore(state) {
  return state.app.wasInDashboardBefore;
}

export function getHasSeenMonitoringHelp(state) {
  return state.app.hasSeenMonitoringHelp;
}

export function getThemeSource(state) {
  return state.app.themeSource;
}

export function getVideoQuality(state) {
  return state.app.videoQuality;
}

export function getIsInDetachMode(state) {
  return state.app.isInDetachMode;
}

export function getWhatsNewContentVersion(state) {
  return state.app.whatsNewContentVersion;
}

export function getIsDebugEnabled(state) {
  return state.app.enableDebug;
}

export function getVideoMode(state) {
  return state.app.videoMode;
}

export function getLastRole(state) {
  return state.app.lastRole;
}

export function getAutoUpdateVideoMode(state) {
  return state.app.autoUpdateVideoMode;
}
